"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    ref: "dropDownWrapper",
    class: "tw group relative text-base"
};
const _hoisted_2 = ["id", "name", "disabled", "required", "aria-describedby"];
const _hoisted_3 = ["value"];
const _hoisted_4 = ["for"];
const _hoisted_5 = ["data-key", "onClick"];
const _hoisted_6 = ["src"];
const vue_3 = require("vue");
const SvgIcon_vue_1 = __importDefault(require("./SvgIcon/SvgIcon.vue"));
const HintText_vue_1 = __importDefault(require("./SharedForm/HintText.vue"));
const ValidationText_vue_1 = __importDefault(require("./SharedForm/ValidationText.vue"));
const core_1 = require("@vueuse/core");
const use_input_validation_1 = __importDefault(require("../composables/use-input-validation"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedDropdown',
    props: {
        disabled: { type: Boolean },
        displayName: {},
        hint: {},
        hintPermanent: { type: Boolean },
        icons: {},
        imageUrls: {},
        label: {},
        modelValue: {},
        name: {},
        options: { default: () => ({}) },
        placeholder: {},
        required: { type: Boolean },
        value: {},
        forcedErrorMessage: {},
        requiredErrorMessage: {},
        dataTestName: { default: "" },
        ariaDescribedby: {}
    },
    emits: ["update:modelValue", "change-error-msg"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const nativeSelectRef = (0, vue_3.useTemplateRef)("nativeSelect");
        const dropDownWrapperRef = (0, vue_3.useTemplateRef)("dropDownWrapper");
        const customOptionsListRef = (0, vue_3.useTemplateRef)("customOptionsList");
        const isEm64 = (0, core_1.useBreakpoints)({ em64: "64em" }).greaterOrEqual("em64");
        const isCustomDropdown = (0, vue_3.computed)(() => isEm64.value);
        const customOptionsList_isOpen = (0, vue_3.ref)(false);
        const customOptionsList_focusedOptionKey = (0, vue_3.ref)(null);
        const hasPlaceholder = !!props.placeholder;
        const generatedOptions = hasPlaceholder ? Object.assign({ "": props.placeholder }, props.options) : props.options;
        const generatedIcons = hasPlaceholder && props.icons ? [""].concat(props.icons) : undefined;
        const generatedImageUrls = hasPlaceholder && props.imageUrls ? [""].concat(props.imageUrls) : undefined;
        const { isValidationVisible, errorMessage, handleInput } = (0, use_input_validation_1.default)(nativeSelectRef, props.displayName || props.name || "Feld", undefined, (0, vue_3.toRef)(props, "forcedErrorMessage"), props.requiredErrorMessage);
        (0, vue_3.watch)([isValidationVisible, errorMessage], () => {
            emit("change-error-msg", event, { errorMessage: errorMessage.value });
        });
        const selectedOption = props.modelValue === undefined
            ? (0, vue_3.ref)(props.value || "")
            : (0, vue_3.computed)({
                get() {
                    return props.modelValue;
                },
                set(val) {
                    emit("update:modelValue", val || "");
                },
            });
        const hasError = (0, vue_3.computed)(() => isValidationVisible.value);
        const isPopulated = (0, vue_3.computed)(() => !!selectedOption.value);
        // Methods
        const handleMousedownOnSelect = (e) => {
            if (!isCustomDropdown.value)
                return;
            e.preventDefault();
            customDropDown_toggle();
        };
        const customDropDown_focusSelected = (customOptionsList_focusedOptionKey) => {
            var _a, _b;
            (_b = (_a = customOptionsListRef.value) === null || _a === void 0 ? void 0 : _a.querySelector(`button[data-key=${customOptionsList_focusedOptionKey}]`)) === null || _b === void 0 ? void 0 : _b.focus();
        };
        const customDropDown_close = () => {
            customOptionsList_isOpen.value = false;
        };
        const customDropDown_toggle = () => {
            customOptionsList_isOpen.value = !customOptionsList_isOpen.value;
            if (!isCustomDropdown.value)
                return;
            if (customOptionsList_isOpen.value && selectedOption.value)
                (0, vue_3.nextTick)(() => {
                    customOptionsList_focusedOptionKey.value = selectedOption.value;
                    customDropDown_focusSelected(customOptionsList_focusedOptionKey.value);
                });
        };
        const focusNativeSelect = () => {
            (0, vue_3.nextTick)(() => { var _a; return (_a = nativeSelectRef.value) === null || _a === void 0 ? void 0 : _a.focus(); });
        };
        const customDropDown_select = (key) => {
            if (key === "none") {
                key = "";
            }
            selectedOption.value = String(key);
            customDropDown_close();
            focusNativeSelect();
        };
        const handleSpaceAndEnter = (e) => {
            if (!isCustomDropdown.value)
                return;
            e.preventDefault();
            customDropDown_toggle();
        };
        const handleArrowUpAndDown = (e) => {
            if (!isCustomDropdown.value)
                return;
            e.preventDefault();
            if (!customOptionsList_isOpen.value)
                return customDropDown_toggle();
            const optionsKeys = Object.keys(generatedOptions);
            const focusedIndex = optionsKeys.indexOf(customOptionsList_focusedOptionKey.value || "");
            const add = e.key === "ArrowUp" ? -1 : 1;
            const newIndex = Math.min(Math.max(0, focusedIndex + add), optionsKeys.length - 1);
            customOptionsList_focusedOptionKey.value = optionsKeys[newIndex];
            customDropDown_focusSelected(customOptionsList_focusedOptionKey.value);
        };
        const handleTap = (e) => {
            var _a;
            if (!isCustomDropdown.value)
                return;
            if (customOptionsList_isOpen.value) {
                e.preventDefault();
                const key = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.getAttribute("data-key");
                if (key)
                    customDropDown_select(key);
                customDropDown_close();
                focusNativeSelect();
            }
        };
        const handleEscape = () => {
            customDropDown_close();
            focusNativeSelect();
        };
        (0, core_1.onKeyStroke)([" ", "Spacebar", "Enter"], (e) => handleSpaceAndEnter(e), {
            target: nativeSelectRef,
        });
        (0, core_1.onKeyStroke)(["ArrowUp", "ArrowDown"], (e) => handleArrowUpAndDown(e), {
            target: dropDownWrapperRef,
        });
        (0, core_1.onKeyStroke)("Tab", (e) => handleTap(e), { target: dropDownWrapperRef });
        (0, core_1.onKeyStroke)("Escape", () => handleEscape(), { target: dropDownWrapperRef });
        (0, core_1.onClickOutside)(dropDownWrapperRef, () => customDropDown_close());
        (0, vue_3.watch)(() => selectedOption.value, () => {
            customDropDown_close();
            handleInput();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", (0, vue_2.normalizeProps)({
                        id: _ctx.name,
                        ref: "nativeSelect",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((0, vue_2.isRef)(selectedOption) ? (selectedOption).value = $event : null)),
                        name: _ctx.name,
                        class: ["peer relative flex h-14 w-full select-none appearance-none items-center truncate rounded border-none bg-white pl-4 pr-10 outline outline-1 -outline-offset-1 focus-visible:outline-[3px] focus-visible:-outline-offset-[3px] focus-visible:outline-black-primary", {
                                'text-gray-70': !customOptionsList_isOpen.value && !_ctx.disabled && !hasError.value && !isPopulated.value,
                                'text-gray-80 outline-gray-70': !customOptionsList_isOpen.value && !_ctx.disabled && !hasError.value,
                                'text-black-primary outline-[3px] outline-black-primary': customOptionsList_isOpen.value && !hasError.value,
                                'outline-error focus-visible:outline-error': hasError.value,
                                'focus-visible:text-black-primary supportsHover:hover:text-black-primary supportsHover:hover:outline-black-primary': !_ctx.disabled && !hasError.value,
                                'cursor-pointer': !_ctx.disabled,
                                'pointer-events-auto cursor-not-allowed text-gray-50': _ctx.disabled,
                            }],
                        style: { "-webkit-tap-highlight-color": "transparent" },
                        disabled: _ctx.disabled,
                        required: _ctx.required,
                        [_ctx.dataTestName || ""]: '',
                        "aria-describedby": _ctx.ariaDescribedby,
                        onMousedown: handleMousedownOnSelect
                    }), [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(generatedOptions), (optionValue, key) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                key: optionValue,
                                value: key
                            }, (0, vue_2.toDisplayString)(optionValue), 9, _hoisted_3));
                        }), 128))
                    ], 16, _hoisted_2), [
                        [vue_2.vModelSelect, (0, vue_2.unref)(selectedOption)]
                    ]),
                    (0, vue_2.createElementVNode)("label", {
                        for: _ctx.name,
                        class: (0, vue_2.normalizeClass)(["pointer-events-none absolute -top-2.5 left-3 whitespace-nowrap bg-white px-1 text-sm", {
                                'text-gray-80': !customOptionsList_isOpen.value && !_ctx.disabled && !hasError.value,
                                'text-black-primary': customOptionsList_isOpen.value && !_ctx.disabled && !hasError.value,
                                'peer-focus-visible:text-black-primary supportsHover:peer-hover:text-black-primary': !_ctx.disabled && !hasError.value,
                                'text-gray-50': _ctx.disabled,
                                'text-error': hasError.value,
                            }])
                    }, (0, vue_2.toDisplayString)(_ctx.label), 11, _hoisted_4),
                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                        class: (0, vue_2.normalizeClass)(["pointer-events-none absolute right-4 top-1/2 size-5 -translate-y-1/2 transition-transform", {
                                'rotate-180': customOptionsList_isOpen.value,
                                'text-black-primary': isPopulated.value && !_ctx.disabled,
                                'text-error': hasError.value,
                                'text-gray-50': _ctx.disabled,
                            }]),
                        "icon-name": "arrow-down-thin"
                    }, null, 8, ["class"]),
                    (0, vue_2.createElementVNode)("ul", {
                        ref: "customOptionsList",
                        class: (0, vue_2.normalizeClass)(["absolute left-0 top-15 z-20 w-full overflow-hidden rounded text-black-primary shadow-4", { hidden: !customOptionsList_isOpen.value || !isCustomDropdown.value }]),
                        style: { "clip-path": "inset(0 -20px -20px -20px)" }
                    }, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(generatedOptions), (option, key, i) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: key }, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "flex h-12 w-full select-none items-center bg-white px-4 outline-none focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-black-primary supportsHover:hover:bg-gray-40",
                                    style: { "-webkit-tap-highlight-color": "transparent" },
                                    "data-key": key,
                                    type: "button",
                                    tabindex: "-1",
                                    onClick: ($event) => (customDropDown_select(key))
                                }, [
                                    ((0, vue_2.unref)(generatedIcons) && (0, vue_2.unref)(generatedIcons)[i])
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SvgIcon_vue_1.default, {
                                            key: 0,
                                            class: "mr-2 size-5 shrink-0",
                                            "icon-name": (0, vue_2.unref)(generatedIcons)[i]
                                        }, null, 8, ["icon-name"]))
                                        : ((0, vue_2.unref)(generatedImageUrls) && (0, vue_2.unref)(generatedImageUrls)[i])
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("img", {
                                                key: 1,
                                                src: (0, vue_2.unref)(generatedImageUrls)[i],
                                                alt: "",
                                                class: "mr-2 size-5 shrink-0"
                                            }, null, 8, _hoisted_6))
                                            : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createElementVNode)("span", {
                                        class: (0, vue_2.normalizeClass)(["block flex-1 text-left leading-none", { 'ml-7': (0, vue_2.unref)(generatedIcons) && !(0, vue_2.unref)(generatedIcons)[i] }])
                                    }, (0, vue_2.toDisplayString)(option), 3)
                                ], 8, _hoisted_5)
                            ]));
                        }), 128))
                    ], 2)
                ], 512),
                (_ctx.hint && (_ctx.hintPermanent || !(0, vue_2.unref)(isValidationVisible)))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(HintText_vue_1.default, {
                        key: 0,
                        "no-indent": "",
                        "hint-text": _ctx.hint
                    }, null, 8, ["hint-text"]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(isValidationVisible))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ValidationText_vue_1.default, {
                        key: 1,
                        "no-indent": "",
                        "data-test-name": _ctx.dataTestName,
                        "error-message": (0, vue_2.unref)(errorMessage)
                    }, null, 8, ["data-test-name", "error-message"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
